import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useQualityReviewPageStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    padding: "16px 32px",
  },
  content: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[6],
    width: "100%",
    flex: "1 1 auto",
    minHeight: 0,
  },
  scorecardWrapper: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    minHeight: 0,
  },
});
